__turbopack_context__.v({
  "component": "style-module-scss-module__2iTSFG__component",
  "favourited-text": "style-module-scss-module__2iTSFG__favourited-text",
  "icon": "style-module-scss-module__2iTSFG__icon",
});
